import { useInvalidateCarriersQuery } from "./use-carriers-query";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export function useDeleteCarrierFromShop(shopId: string) {
	return useApiMutation("delete", "/shops/{shopId}/carriers/{carrierId}", {
		invalidate: [
			useInvalidateShop(shopId),
			useInvalidateCarriersQuery({ shopId }),
		],
		mapVariables: ({ carrierId }: { carrierId: string }) => ({
			params: { path: { shopId, carrierId } },
		}),
	});
}
